import styled from 'styled-components';

export const RollableWrapper = styled.div<{ expanded: boolean }>`
  display: ${props => (props.expanded ? 'block' : 'none')};
  max-height: ${props => (props.expanded ? 'auto' : 0)};
`;
